import axios from "axios";
import router from "./../../router";
const state = {
  loading: true,
  lang: null,
  article: {},
};

const getters = {
  getArticleData: (state) => {
    return state.article;
  },
  getArticleLoading: (state) => {
    return state.loading;
  },
};

const mutations = {
  setArticleData: (state, articleData) => {
    const newArticle = {};
    const articleParams = Object.keys(articleData);
    articleParams.forEach((key) => (newArticle[key] = articleData[key]));
    state.article = newArticle;
  },
  setArticleLoadingData: (state, loading) => {
    state.loading = loading;
  },
  setLanguage: ( state, lang ) => {
    state.lang = lang;
  },
};

const actions = {
  async setArticle({ commit }, baseId) {
    commit("setArticleLoadingData", true);
    let query = JSON.parse(JSON.stringify(router.app.$route.query));
    let { data } = await axios.get("article/" + baseId, {
      params: { ...query },
    });
    let article = data.article;
    commit("setArticleData", article);
    if (data.lang) {
      query["lang"] = data.lang;
      if (!query.lang) {
        router.app.$router.replace({ query: query });
      } else {
        router.app.$router.push({ query: query });
      }
    }
    commit("setArticleLoadingData", false);

  },
  unsetArticle({ commit }){
    commit("setArticleData", {});
  },
  setArticleLoading({ commit }, loading) {
    commit("setArticleLoadingData", loading);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
